module.exports = __webpack_public_path__ + "img/1514604288.777f873f.jpg";